import { Component, Input, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  WmsDialogComponent,
  WmsDialogHeaderComponent,
  WmsDialogBodyComponent,
  WmsDialogFooterComponent
} from '@wms/components';
import { BaseComponent } from '@wms/app/components';
import { DialogService } from '@wms/app/services';
import {RouterStateSnapshot} from "@angular/router";

@Component({
  selector: 'wms-unsaved-changes-dialog',
  standalone: true,
  imports: [CommonModule, WmsDialogHeaderComponent, WmsDialogBodyComponent, WmsDialogFooterComponent, WmsDialogComponent],
  templateUrl: './wms-unsaved-changes-dialog.component.html',
  styleUrls: ['./wms-unsaved-changes-dialog.component.less']
})
export class WmsUnsavedChangesDialogComponent extends BaseComponent {
  nextState: RouterStateSnapshot | null;
  @Input() id: string;
  @Input() message: string;
  @Input() cancelBtnLabel: string;
  @Input() saveBtnLabel: string;
  @Output() closeEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() saveEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(public dialogService: DialogService) {
    super();
  }
  
  getMessage(){
    let params = this.dialogService.getInstanceById(`unsavedChangesDialog_${this.id}`).dialogParams;
    return this.message || params?.message
  }

  closeModal() {
    this.closeEvent.emit();
    if(this.nextState?.url) {
      this.nextState = null;
    }
  }

  saveChanges() {
    this.saveEvent.emit();
  }

  cancelChanges() {
    this.cancelEvent.emit();
  }
}
